/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../graphql/src/lib/graphql/generated/types'
import { EmergencyStopAdAlertCardAlertFragmentDoc } from './EmergencyStopAdAlertCard/EmergencyStopAdAlertCard.hook'
import { ManualNoShowRequestedAdAlertCardFragmentDoc } from './ManualNoShowRequestedAdAlertCard/ManualNoShowRequestedAdAlertCard.hook'
import { OperatorCallAdAlertCardAlertFragmentDoc } from './OperatorCallAdAlertCard/OperatorCallAdAlertCard.hook'
import { PassengerCallAdAlertCardAlertFragmentDoc } from './PassengerCallAdAlertCard/PassengerCallAdAlertCard.hook'
import { PassengerUnbuckledAdAlertCardAlertFragmentDoc } from './PassengerUnbuckledAdAlertCard/PassengerUnbuckledAdAlertCard.hook'
import { ServiceCancellationAlertCardAlertFragmentDoc } from './ServiceCancellationAdAlertCard/ServiceCancellationAdAlertCard.hook'
import { WaypointAttendanceAdAlertCardFragmentDoc } from './WaypointAttendanceAdAlertCard/WaypointAttendanceAdAlertCard.hook'
export type AdAlertCardAlertFragment = {
  __typename: 'FccAdAlert'
  id: string
  type: Types.FccAdAlertType
  status: Types.FccAdAlertStatus
  vehicle: {
    __typename?: 'Vehicle'
    totalPassengersInVehicle: number | null
    id: string
    inService: boolean | null
    label: number | null
    isSelfDriving: boolean
    fccUpcomingWaypoints: Array<{
      __typename?: 'FccWaypoint'
      id: string
      actions: Array<
        | {
            __typename: 'FccWaypointDeliveryAction'
            id: string
            estimatedAt: string
            pickedUpAt: string | null
            trip: { __typename?: 'Trip'; id: string } | null
            customer: {
              __typename?: 'Customer'
              firstName: string | null
              lastName: string | null
              extendedWalkingTime: boolean
              visualImpairment: boolean | null
            } | null
            seats: {
              __typename?: 'FccWaypointSeatInfo'
              seats: number
              wheelchairs: number
              childSeats: number
              boosterSeats: number
            }
          }
        | { __typename?: 'FccWaypointHubReturnAction' }
        | {
            __typename: 'FccWaypointPickupAction'
            id: string
            adPassengerAuthenticationState: Types.FccPassengerAuthenticationState | null
            tripIsCancelled: boolean | null
            estimatedAt: string
            pickedUpAt: string | null
            notShownUpAt: string | null
            trip: { __typename?: 'Trip'; id: string } | null
            customer: {
              __typename?: 'Customer'
              firstName: string | null
              lastName: string | null
              extendedWalkingTime: boolean
              visualImpairment: boolean | null
            } | null
            seats: {
              __typename?: 'FccWaypointSeatInfo'
              seats: number
              wheelchairs: number
              childSeats: number
              boosterSeats: number
            }
          }
        | { __typename?: 'FccWaypointReallocationAction' }
      >
      stop: {
        __typename?: 'Stop'
        id: string
        names: Partial<Record<'de' | 'en', string>>
        serviceArea: { __typename?: 'ServiceArea'; id: string }
      } | null
    }> | null
  } | null
  assignee: {
    __typename?: 'BackofficeUser'
    id: string
    username: string
  } | null
  statusChanges: Array<{
    __typename: 'FccAdAlertStatusChange'
    bySystem: boolean
    date: string
    to: Types.FccAdAlertStatus
    byUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export const AdAlertCardAlertFragmentDoc = gql`
    fragment AdAlertCardAlert on FccAdAlert {
  id
  type
  status
  ...PassengerUnbuckledAdAlertCardAlert
  ...PassengerCallAdAlertCardAlert
  ...OperatorCallAdAlertCardAlert
  ...ServiceCancellationAlertCardAlert
  ...EmergencyStopAdAlertCardAlert
  ...WaypointAttendanceAdAlertCard
  ...ManualNoShowRequestedAdAlertCard
}
    ${PassengerUnbuckledAdAlertCardAlertFragmentDoc}
${PassengerCallAdAlertCardAlertFragmentDoc}
${OperatorCallAdAlertCardAlertFragmentDoc}
${ServiceCancellationAlertCardAlertFragmentDoc}
${EmergencyStopAdAlertCardAlertFragmentDoc}
${WaypointAttendanceAdAlertCardFragmentDoc}
${ManualNoShowRequestedAdAlertCardFragmentDoc}`
